<template>
  <section
    v-aos="animate && 'flip-up'"
    class="w-full overflow-hidden !-mb-2 lg:!-mb-6"
    :class="sectionOuterSpacingClass(data)"
  >
    <PluginsCarousel
      :data="data?.items"
      :pagination="false"
      :navigation="false"
      :autoplay="true"
      :loop="true"
      type="Brands"
      class="client-slider clients-mask"
    >
      <template v-slot="{ slide }">
        <div class="w-full flex justify-center items-center brand-logo-wrapper">
          <AtomsImage
            :media="slide?.logo"
            sizeHint="logo"
            loading="eager"
            :alt="slide?.logo?.alternativeText ?? slide?.logo?.hash ?? slide?.logo?.name"
            class="object-contain object-center duration-500  brand-logo"
          />
        </div>
      </template>
    </PluginsCarousel>
  </section>
</template>
<script setup>
import { sectionOuterSpacingClass } from "~/composables/sectionSpacing";

const props = defineProps({
  data: {
    type: Object,
  },
  animate: { type: Boolean, default: false },
});
</script>
<style scoped>
.brand-logo-wrapper {
  width: 100%;
  max-width: 220px;
  aspect-ratio: 3 / 2;
  padding: 12px 16px;
}

.brand-logo {
  max-height: 120px;
  max-width: 100%;
  width: auto;
  height: auto;
}
</style>
